document.addEventListener('DOMContentLoaded', function() {
    const messageItems = document.querySelectorAll('.section-delivery-messaging-swiper');

    messageItems.forEach(function(item) {
        // Determine if the item is for a specific country or continent
        const regionType = item.getAttribute('data-region'); // 'country' or 'continent'
        const codes = item.getAttribute('data-code').replaceAll(" ", "").split(','); // Allows for multiple codes, removes spaces

        let isRelevant = false; // Flag to determine if the item is relevant to the user

        // Check against the client's country or continent
        if (regionType === 'country' && codes.includes(client_country)) {
            isRelevant = true;
        } else if (regionType === 'continent') {
            // Special handling for EU, excluding GB
            if (codes.includes(client_continent) && !(client_continent === 'EU' && client_country === 'GB')) {
                isRelevant = true;
            }
        }

        // Hide the item if it's not relevant
        if (!isRelevant) {
            item.style.display = 'none';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.section-delivery-messaging-swiper', {
      // Swiper options
      slidesPerView: 3,
      speed: 0,
      spaceBetween: 12,
      loop: true,
      centeredSlides: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
		},
	  pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
		// Enable navigation
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: '1',
          enabled: true
        },
        // when window width is >= 768px (for example, disable swiper)
        768: {
          slidesPerView: '3',
          enabled: false
        }
      }
    });
  });